export default __webpack_public_path__ + "static/blogPost-e344ad865aed137036cca119e0c3c37d.png";